import { Box, Button, Typography } from '@mui/material';
import { Main } from 'layouts';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function Contacto() {
  const S3_URL = process.env.REACT_APP_S3_URL;
  return (
    <Main>
      <Box marginTop={5}>
        <Typography
          variant="h4"
          component="h1"
          color="text.primary"
          align={'center'}
          sx={{
            fontWeight: 700,
          }}
        >
          <FormattedMessage id={'form.title.1'} />
          <Typography
            variant="h4"
            component="span"
            color="primary"
            align={'start'}
            sx={{
              fontWeight: 700,
            }}
          >
            <FormattedMessage id={'form.title.2'} />
          </Typography>
        </Typography>
      </Box>
      <Box
        gap={3}
        justifyContent={'center'}
        alignItems={'start'}
        padding={'2rem'}
        height={'80vh'}
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column',
            md: 'row'
          },
          alignItems: {
            xs: 'center',
            md: 'start'
          },
          padding: {
            xs: '2rem',
            md: '4rem 0 0 0'
          },
          height: {
            xs: '70vh',
            md: '50vh'
          }

        }}
      >
        <Button
          variant={'contained'}
          component={'a'}
          href="https://wa.me/573107852688"
          target="_blank"
          size={'large'}
          id="WhatsApp"
        >
          Hablar en Whatsapp
        </Button>
        <Button
          variant={'contained'}
          component={'a'}
          href="https://meetings.hubspot.com/santiago-valencia1?uuid=9621949e-09fd-43a7-a918-4ae14c5f39e6"
          target="_blank"
          size={'large'}
          id="WhatsApp"
        >
          Agendar una reunión
        </Button>
        <Button
          variant={'contained'}
          component={'a'}
          href={S3_URL + '/pdfs/credenciales-merge.pdf'}
          target="_blank"
          size={'large'}
          id="WhatsApp"
          download
        >
          Descargar credenciales
        </Button>
      </Box>
    </Main>
  );
}
